import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import * as microtaskQueue from "../microtaskQueue";

const nodeObservers = new WeakMap<api_cs.Cnode, Set<() => void>>();

export function on_node_update(node: api_cs.Cnode, callback: () => void): { unsubscribe: () => void } {
	let observers = nodeObservers.get(node);
	if (!observers) {
		observers = new Set();
		nodeObservers.set(node, observers);
	}
	observers.add(callback);
	return {
		unsubscribe: () => {
			observers?.delete(callback);
		},
	};
}

const queue = new WeakMap<api_cs.Cnode, () => void>();

export function notify_node_update(node: api_cs.Cnode): void {
	if (!queue.has(node)) {
		queue.set(
			node,
			microtaskQueue.add(() => {
				const observers = nodeObservers.get(node);
				if (observers) {
					for (const observer of observers) {
						observer();
					}
				}
				queue.delete(node);
			})
		);
	}
}
